import React from 'react';

export const SvgIconOverview = () => (
    <div className="svg-icon svg-icon--overview">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 23">
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path className="fill" d="M.5 9.5v-1a5 5 0 0 1 5-5H9M23.5 9.5v-1a5 5 0 0 0-5-5" />
                <path
                    className="fill"
                    d="M20.5 6.5h-17a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h17a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3z"
                />
                <path d="M20.5 14.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                <path d="M19.5 17.5h4v-6h-4a3 3 0 1 0 0 6zM3.5 6.5L13.777.966a3 3 0 0 1 4.106 1.3L20 6.5M10.571 6.5l7.43-4" />
            </g>
        </svg>
    </div>
);
